<script setup lang="ts">
import { CalendarDays, ChartNoAxesColumnIncreasing, CircleUserRound, Home, Plus } from 'lucide-vue-next'

const tabs = [
  { to: '/', label: '首页', icon: Home },
  { to: '/calendar', label: '日历', icon: CalendarDays },
  { to: '/records', label: '记录', icon: Plus, primary: true },
  { to: '/stats', label: '统计', icon: ChartNoAxesColumnIncreasing },
  { to: '/mine', label: '我的', icon: CircleUserRound }
]
</script>

<template>
  <div class="app-shell">
    <main class="page-container"><RouterView /></main>
    <nav class="bottom-nav" aria-label="主导航">
      <RouterLink v-for="tab in tabs" :key="tab.to" :to="tab.to" class="nav-item" :class="{ primary: tab.primary }">
        <span class="nav-icon"><component :is="tab.icon" :size="tab.primary ? 24 : 22" /></span>
        <span>{{ tab.label }}</span>
      </RouterLink>
    </nav>
  </div>
</template>
